import { fetchApiProcess } from "../../utils/http"
import { feedbackTroublesCreator } from "./feedbackTroublesCreator";


export const feedbackTroublesCallers = {
    feedbackTroubles: () => fetchApiProcess([ 'feedback-troubles' ], feedbackTroublesCreator, {
        version: 'v4.0.0',
    }),
};
